export const actionsList = [
  'accept',
  'add',
  'approve',
  'back',
  'cancel',
  'change',
  'clear',
  'close',
  'confirmation',
  'continue',
  'create',
  'create_form',
  'create_field',
  'create_new',
  'delete',
  'delete_confirmation',
  'details',
  'download',
  'edit',
  'expand',
  'finish',
  'generate',
  'hide',
  'login',
  'logout',
  'new',
  'no',
  'preview',
  'refuse',
  'register',
  'reject',
  'reload',
  'replace',
  'resend',
  'resend_email',
  'save',
  'save_create',
  'search',
  'send',
  'show',
  'show_more',
  'show_less',
  'start',
  'subscribe',
  'unsubscribe',
  'upload',
  'upload_replace',
  'view',
  'view_more',
  'view_less',
  'yes',
  'copy',
  'submitted',
  'navigate_to',
  'navigate_back',
  'open_modal',
  'confirm',
  'help',
  'threeD_model',
  'review'
] as const;
export type Action = typeof actionsList[number];

export type ActionSet = {[K in typeof actionsList[number]]: K};


// // Define subtypes for each category
// export const crudActionsList = [
//   'add',
//   'create',
//   'create_form',
//   'create_field',
//   'create_new',
//   'register',
//   'new', // Create
//   'view',
//   'view_more',
//   'view_less',
//   'details',
//   'preview',
//   'show',
//   'show_more',
//   'show_less', // Read
//   'edit', 'update', 'change', 'replace', 'upload_replace', 'resend', 'resend_email', // Update
//   'delete' // Delete
// ] as const;

// export const confirmationActions = [
//   'yes', 'accept', 'approve', 'confirm', 'submitted', // Confirm/Approve
//   'no', 'cancel', 'refuse', 'reject' // Decline/Reject
// ] as const;

// export const navigationActions = [
//   'back', 'continue', 'expand', 'hide', 'show', 'show_more', 'show_less', // Navigation
//   'start', 'finish', 'reload', 'close' // System Control
// ] as const;

// export const fileDataManagementActions = [
//   'upload', 'download', 'copy', // File Operations
//   'save', 'generate', 'clear' // Data Operations
// ] as const;

// export const accountSessionActions = [
//   'login', 'logout', // Session Management
//   'subscribe', 'unsubscribe' // Subscription Management
// ] as const;

// export const communicationActions = [
//   'send', 'resend', 'resend_email' // Send/Receive
// ] as const;

// export const searchActions = [
//   'search' // Search
// ] as const;

// export const miscellaneousActions = [
//   'confirmation' // Miscellaneous Actions
// ] as const;

// // // Create types for each category
// // export type CrudAction = typeof crudActions[number];
// // export type ConfirmationAction = typeof confirmationActions[number];
// // export type NavigationAction = typeof navigationActions[number];
// // export type FileDataManagementAction = typeof fileDataManagementActions[number];
// // export type AccountSessionAction = typeof accountSessionActions[number];
// // export type CommunicationAction = typeof communicationActions[number];
// // export type SearchAction = typeof searchActions[number];
// // export type MiscellaneousAction = typeof miscellaneousActions[number];

// // // Define a combined union type that includes all action subtypes
// // export type Action =
// //   CrudAction | ConfirmationAction | NavigationAction | FileDataManagementAction | AccountSessionAction | CommunicationAction | SearchAction | MiscellaneousAction;

// // // Define a mapped type for all actions as a union of separate subtypes
// // export type ActionTypeSet = {
// //   [K in Action]: K;
// // };

// // // To maintain the complete list as a constant array
// // export const actionsList = [
// //   ...crudActions,
// //   ...confirmationActions,
// //   ...navigationActions,
// //   ...fileDataManagementActions,
// //   ...accountSessionActions,
// //   ...communicationActions,
// //   ...searchActions,
// //   ...miscellaneousActions
// // ] as const;

// // export type AllActions = typeof actionsList[number];
